export default "__VITE_ASSET__xuomyD5w__"